// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { register } from "../actions/authActions";
// import { Box, Container, Typography, TextField, MenuItem, InputAdornment, IconButton, LinearProgress } from "@mui/material";
// import LoadingButton from "@mui/lab/LoadingButton";
// import { useNavigate } from "react-router-dom";
// import { 
//   Person, 
//   Phone, 
//   Business, 
//   LocationOn, 
//   Lock, 
//   Badge,
//   ArrowForward,
//   ArrowBack,
//   Login,
//   CheckCircle
// } from "@mui/icons-material";
// import { getMaxServiceNumber } from "../service/authService";

// const Registration = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
  
//   const [loading, setLoading] = useState(false);
//   const [currentStep, setCurrentStep] = useState(0);
//   const [loadingServiceNo, setLoadingServiceNo] = useState(true);
//   const [formData, setFormData] = useState({
//     ServiceNo: "",
//     Name: "",
//     MobileNo: "",
//     company: "",
//     role: "",
//     status: "A",
//     Location: "",
//     SLocation: "",
//     password: "",
//     qr: "N"
//   });
  
//   const [errors, setErrors] = useState({});

//   const steps = [
//     {
//       title: "Personal Info",
//       subtitle: "Let's start with your basic details",
//       fields: ["ServiceNo", "Name"]
//     },
//     {
//       title: "Contact Details",
//       subtitle: "How can we reach you?",
//       fields: ["MobileNo"]
//     },
//     {
//       title: "Work Information",
//       subtitle: "Tell us about your workplace",
//       fields: ["company", "role"]
//     },
//     {
//       title: "Location Details",
//       subtitle: "Where do you work?",
//       fields: ["Location", "SLocation"]
//     },
//     {
//       title: "Security",
//       subtitle: "Create your password",
//       fields: ["password"]
//     }
//   ];

//   useEffect(() => {
//     // Fetch max service number when component mounts
//     const fetchMaxServiceNumber = async () => {
//       try {
//         setLoadingServiceNo(true);
//         const response = await getMaxServiceNumber();
        
//         if (response.resultSet && response.resultSet[0] && response.resultSet[0].maxid) {
//           const maxId = response.resultSet[0].maxid;
//           // Convert to number, increment, and set as initial value
//           const nextServiceNo = (parseInt(maxId) ).toString();
          
//           setFormData(prev => ({
//             ...prev,
//             ServiceNo: nextServiceNo
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching max service number:", error);
//         // Optionally set a default or show error message
//         alert("Unable to fetch service number. Please enter manually.");
//       } finally {
//         setLoadingServiceNo(false);
//       }
//     };

//     fetchMaxServiceNumber();

//     // Existing useEffect body
//     document.body.style.margin = '0';
//     document.body.style.padding = '0';
//     document.body.style.backgroundColor = '#0f172a';
//     document.documentElement.style.margin = '0';
//     document.documentElement.style.padding = '0';
//     document.documentElement.style.backgroundColor = '#0f172a';

//     return () => {
//       document.body.style.margin = '';
//       document.body.style.padding = '';
//       document.body.style.backgroundColor = '';
//       document.documentElement.style.margin = '';
//       document.documentElement.style.padding = '';
//       document.documentElement.style.backgroundColor = '';
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
    
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ""
//       }));
//     }
//   };

//   const validateStep = (stepIndex) => {
//     const newErrors = {};
//     const currentFields = steps[stepIndex].fields;
    
//     currentFields.forEach(field => {
//       if (field === "SLocation") return; // Optional field
      
//       if (!formData[field] || !formData[field].toString().trim()) {
//         newErrors[field] = "This field is required";
//       } else if (field === "MobileNo" && formData[field].length < 10) {
//         newErrors[field] = "Enter valid mobile number";
//       } else if (field === "password" && formData[field].length < 8) {
//         newErrors[field] = "Password must be at least 8 characters";
//       }
//     });
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleNext = () => {
//     if (validateStep(currentStep)) {
//       if (currentStep < steps.length - 1) {
//         setCurrentStep(prev => prev + 1);
//       } else {
//         handleSubmit();
//       }
//     }
//   };

//   const handleBack = () => {
//     if (currentStep > 0) {
//       setCurrentStep(prev => prev - 1);
//       setErrors({});
//     }
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
    
//     try {
//       const result = await dispatch(register(formData));
      
//       if (result.success) {
//         alert("Registration successful! Please login.");
//         navigate("/");
//       } else {
//         alert(result.error?.message || "Registration failed. Please try again.");
//       }
//     } catch (err) {
//       console.error("Registration error:", err);
//       alert("An error occurred during registration.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const progress = ((currentStep + 1) / steps.length) * 100;

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         width: "100vw",
//         background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         margin: 0,
//         padding: 0,
//         overflow: "hidden",
//       }}
//     >
//       {/* Animated Background */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: "-10%",
//           right: "-5%",
//           width: "500px",
//           height: "500px",
//           borderRadius: "50%",
//           background: "radial-gradient(circle, rgba(59, 130, 246, 0.15) 0%, transparent 70%)",
//           animation: "float 20s ease-in-out infinite",
//           "@keyframes float": {
//             "0%, 100%": { transform: "translate(0, 0) scale(1)" },
//             "50%": { transform: "translate(-50px, 50px) scale(1.1)" },
//           },
//         }}
//       />

//       <Container
//         maxWidth="sm"
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           padding: { xs: 2, sm: 3 },
//           zIndex: 1,
//         }}
//       >
//         <Box
//           sx={{
//             width: "100%",
//             maxWidth: "500px",
//             background: "rgba(255, 255, 255, 0.05)",
//             backdropFilter: "blur(20px)",
//             borderRadius: "24px",
//             border: "1px solid rgba(255, 255, 255, 0.1)",
//             boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
//             padding: { xs: 3, sm: 4 },
//             position: "relative",
//             overflow: "hidden",
//           }}
//         >
//           {/* Top Gradient */}
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               right: 0,
//               height: "4px",
//               background: "linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899)",
//             }}
//           />

//           {/* Progress Bar */}
//           <Box sx={{ mb: 4 }}>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//               <Typography sx={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "0.875rem", fontWeight: 500 }}>
//                 Step {currentStep + 1} of {steps.length}
//               </Typography>
//               <Typography sx={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "0.875rem", fontWeight: 500 }}>
//                 {Math.round(progress)}%
//               </Typography>
//             </Box>
//             <LinearProgress
//               variant="determinate"
//               value={progress}
//               sx={{
//                 height: "6px",
//                 borderRadius: "10px",
//                 backgroundColor: "rgba(255, 255, 255, 0.1)",
//                 "& .MuiLinearProgress-bar": {
//                   background: "linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899)",
//                   borderRadius: "10px",
//                 },
//               }}
//             />
//           </Box>

//           {/* Step Indicators */}
//           <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mb: 3 }}>
//             {steps.map((step, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   width: "12px",
//                   height: "12px",
//                   borderRadius: "50%",
//                   background: index <= currentStep 
//                     ? "linear-gradient(135deg, #3b82f6, #8b5cf6)" 
//                     : "rgba(255, 255, 255, 0.2)",
//                   transition: "all 0.3s ease",
//                   transform: index === currentStep ? "scale(1.3)" : "scale(1)",
//                 }}
//               />
//             ))}
//           </Box>

//           {/* Header */}
//           <Box textAlign="center" mb={4}>
//             <Typography
//               variant="h5"
//               sx={{
//                 fontWeight: 700,
//                 color: "#fff",
//                 mb: 0.5,
//                 fontSize: { xs: "1.5rem", sm: "1.75rem" },
//               }}
//             >
//               {steps[currentStep].title}
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.5)",
//                 fontSize: { xs: "0.875rem", sm: "0.95rem" },
//               }}
//             >
//               {steps[currentStep].subtitle}
//             </Typography>
//           </Box>

//           {/* Form Container with Slide Animation */}
//           <Box
//             sx={{
//               position: "relative",
//               minHeight: "280px",
//               overflow: "hidden",
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                 transform: `translateX(-${currentStep * 100}%)`,
//               }}
//             >
//               {/* Step 1: Personal Info */}
//               <Box sx={{ minWidth: "100%", px: 1 }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
//                   <TextField
//                     placeholder="Service Number"
//                     name="ServiceNo"
//                     value={formData.ServiceNo}
//                     onChange={handleChange}
//                     error={!!errors.ServiceNo}
//                     helperText={errors.ServiceNo}
//                     autoFocus
//                     disabled={loadingServiceNo}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Badge sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
//                         </InputAdornment>
//                       ),
//                       endAdornment: loadingServiceNo && (
//                         <InputAdornment position="end">
//                           <Box
//                             sx={{
//                               width: 16,
//                               height: 16,
//                               border: "2px solid rgba(255, 255, 255, 0.3)",
//                               borderTop: "2px solid #3b82f6",
//                               borderRadius: "50%",
//                               animation: "spin 1s linear infinite",
//                               "@keyframes spin": {
//                                 "0%": { transform: "rotate(0deg)" },
//                                 "100%": { transform: "rotate(360deg)" }
//                               }
//                             }}
//                           />
//                         </InputAdornment>
//                       )
//                     }}
//                     sx={textFieldStyles}
//                   />

//                   <TextField
//                     placeholder="Full Name"
//                     name="Name"
//                     value={formData.Name}
//                     onChange={handleChange}
//                     error={!!errors.Name}
//                     helperText={errors.Name}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Person sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={textFieldStyles}
//                   />
                  
//                   {/* Info message about service number */}
//                   {!loadingServiceNo && formData.ServiceNo && (
//                     <Typography sx={{ 
//                       color: "rgba(59, 130, 246, 0.8)", 
//                       fontSize: "0.75rem", 
//                       fontStyle: "italic",
//                       mt: -1,
//                       ml: 1
//                     }}>
//                       Auto-generated service number. You can edit if needed.
//                     </Typography>
//                   )}
//                 </Box>
//               </Box>

//               {/* Step 2: Contact */}
//               <Box sx={{ minWidth: "100%", px: 1 }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
//                   <TextField
//                     placeholder="Mobile Number"
//                     name="MobileNo"
//                     value={formData.MobileNo}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setFormData(prev => ({ ...prev, MobileNo: value }));
//                       if (errors.MobileNo) {
//                         setErrors(prev => ({ ...prev, MobileNo: "" }));
//                       }
//                     }}
//                     type="tel"
//                     error={!!errors.MobileNo}
//                     helperText={errors.MobileNo}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Phone sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={textFieldStyles}
//                   />
                  
//                   <Box
//                     sx={{
//                       padding: 3,
//                       borderRadius: "16px",
//                       background: "rgba(59, 130, 246, 0.1)",
//                       border: "1px solid rgba(59, 130, 246, 0.3)",
//                       textAlign: "center",
//                     }}
//                   >
//                     <Phone sx={{ fontSize: 40, color: "#3b82f6", mb: 1 }} />
//                     <Typography sx={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "0.875rem" }}>
//                       We'll send a verification code to this number
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>

//               {/* Step 3: Work Info */}
//               <Box sx={{ minWidth: "100%", px: 1 }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
//                   <TextField
//                     placeholder="Company Name"
//                     name="company"
//                     value={formData.company}
//                     onChange={handleChange}
//                     error={!!errors.company}
//                     helperText={errors.company}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Business sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={textFieldStyles}
//                   />

//                   <TextField
//                     select
//                     placeholder="Select Role"
//                     name="role"
//                     value={formData.role}
//                     onChange={handleChange}
//                     error={!!errors.role}
//                     helperText={errors.role}
//                     sx={textFieldStyles}
//                     SelectProps={{
//                       displayEmpty: true,
//                     }}
//                   >
//                     <MenuItem value="" disabled>Select Your Role</MenuItem>
//                     <MenuItem value="A">Admin</MenuItem>
//                     <MenuItem value="U">User</MenuItem>
//                     <MenuItem value="S">Supervisor</MenuItem>
//                   </TextField>
//                 </Box>
//               </Box>

//               {/* Step 4: Location Details */}
//               <Box sx={{ minWidth: "100%", px: 1 }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
//                   <TextField
//                     placeholder="Primary Location"
//                     name="Location"
//                     value={formData.Location}
//                     onChange={handleChange}
//                     error={!!errors.Location}
//                     helperText={errors.Location}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <LocationOn sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={textFieldStyles}
//                   />

//                   <TextField
//                     placeholder="Sub Location (Optional)"
//                     name="SLocation"
//                     value={formData.SLocation}
//                     onChange={handleChange}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <LocationOn sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={textFieldStyles}
//                   />

//                   <Box
//                     sx={{
//                       padding: 3,
//                       borderRadius: "16px",
//                       background: "rgba(139, 92, 246, 0.1)",
//                       border: "1px solid rgba(139, 92, 246, 0.3)",
//                       textAlign: "center",
//                     }}
//                   >
//                     <LocationOn sx={{ fontSize: 40, color: "#8b5cf6", mb: 1 }} />
//                     <Typography sx={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "0.875rem" }}>
//                       This helps us assign you to the right workplace
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>

//               {/* Step 5: Security */}
//               <Box sx={{ minWidth: "100%", px: 1 }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
//                   <TextField
//                     placeholder="Create Password (min 8 characters)"
//                     name="password"
//                     type="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     error={!!errors.password}
//                     helperText={errors.password}
//                     autoComplete="new-password"
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Lock sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={textFieldStyles}
//                   />

//                   <Box
//                     sx={{
//                       padding: 3,
//                       borderRadius: "16px",
//                       background: "rgba(236, 72, 153, 0.1)",
//                       border: "1px solid rgba(236, 72, 153, 0.3)",
//                     }}
//                   >
//                     <Lock sx={{ fontSize: 40, color: "#ec4899", mb: 1, display: "block", mx: "auto" }} />
//                     <Typography sx={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "0.875rem", textAlign: "center", mb: 1 }}>
//                       Password Requirements:
//                     </Typography>
//                     <Box sx={{ textAlign: "left", pl: 2 }}>
//                       <Typography sx={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "0.8rem", mb: 0.5 }}>
//                         • At least 8 characters long
//                       </Typography>
//                       <Typography sx={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "0.8rem", mb: 0.5 }}>
//                         • Mix of letters and numbers
//                       </Typography>
//                       <Typography sx={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "0.8rem" }}>
//                         • Keep it secure and memorable
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           {/* Navigation Buttons */}
//           <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
//             {currentStep > 0 && (
//               <LoadingButton
//                 onClick={handleBack}
//                 startIcon={<ArrowBack />}
//                 sx={{
//                   flex: 1,
//                   height: "56px",
//                   borderRadius: "12px",
//                   background: "rgba(255, 255, 255, 0.05)",
//                   border: "1px solid rgba(255, 255, 255, 0.1)",
//                   color: "#fff",
//                   fontSize: "1rem",
//                   fontWeight: 600,
//                   textTransform: "none",
//                   "&:hover": {
//                     background: "rgba(255, 255, 255, 0.08)",
//                     border: "1px solid rgba(255, 255, 255, 0.2)",
//                   },
//                 }}
//               >
//                 Back
//               </LoadingButton>
//             )}

//             <LoadingButton
//               onClick={handleNext}
//               loading={loading}
//               endIcon={currentStep === steps.length - 1 ? <CheckCircle /> : <ArrowForward />}
//               sx={{
//                 flex: 1,
//                 height: "56px",
//                 borderRadius: "12px",
//                 background: "linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)",
//                 color: "#fff",
//                 fontSize: "1rem",
//                 fontWeight: 600,
//                 textTransform: "none",
//                 boxShadow: "0 10px 30px rgba(236, 72, 153, 0.3)",
//                 "&:hover": {
//                   background: "linear-gradient(135deg, #db2777 0%, #7c3aed 100%)",
//                   boxShadow: "0 15px 40px rgba(236, 72, 153, 0.4)",
//                   transform: "translateY(-2px)",
//                 },
//                 "&.Mui-disabled": {
//                   background: "rgba(255, 255, 255, 0.1)",
//                   color: "rgba(255, 255, 255, 0.4)",
//                 },
//               }}
//             >
//               {currentStep === steps.length - 1 ? "Complete Registration" : "Next"}
//             </LoadingButton>
//           </Box>

//           {/* Login Link */}
//           <Box
//             onClick={() => navigate("/")}
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 1,
//               padding: "12px",
//               borderRadius: "12px",
//               cursor: "pointer",
//               transition: "all 0.3s ease",
//               mt: 3,
//               "&:hover": {
//                 background: "rgba(255, 255, 255, 0.05)",
//               },
//             }}
//           >
//             <Login sx={{ color: "rgba(255, 255, 255, 0.5)", fontSize: 18 }} />
//             <Typography sx={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "0.875rem", fontWeight: 500 }}>
//               Already have an account? Sign In
//             </Typography>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// const textFieldStyles = {
//   "& .MuiOutlinedInput-root": {
//     backgroundColor: "rgba(255, 255, 255, 0.05)",
//     borderRadius: "12px",
//     height: "56px",
//     color: "#fff",
//     border: "1px solid rgba(255, 255, 255, 0.1)",
//     "& fieldset": { border: "none" },
//     "&:hover": {
//       backgroundColor: "rgba(255, 255, 255, 0.08)",
//       border: "1px solid rgba(255, 255, 255, 0.2)",
//     },
//     "&.Mui-focused": {
//       backgroundColor: "rgba(255, 255, 255, 0.08)",
//       border: "1px solid rgba(236, 72, 153, 0.5)",
//       boxShadow: "0 0 0 4px rgba(236, 72, 153, 0.1)",
//     },
//   },
//   "& .MuiOutlinedInput-input": {
//     "&::placeholder": {
//       color: "rgba(255, 255, 255, 0.4)",
//       opacity: 1,
//     },
//   },
//   "& .MuiFormHelperText-root": {
//     color: "#fca5a5",
//     marginLeft: "8px",
//   },
// };

// export default Registration;

// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { register } from "../actions/authActions";
// import {
//   Box,
//   Container,
//   Typography,
//   TextField,
//   MenuItem,
//   InputAdornment,
//   IconButton,
//   Paper,
//   Alert,
//   FormControlLabel,
//   Checkbox,
//   Link,
//   CircularProgress
// } from "@mui/material";
// import LoadingButton from "@mui/lab/LoadingButton";
// import { useNavigate } from "react-router-dom";
// import {
//   Person,
//   Phone,
//   Business,
//   LocationOn,
//   Lock,
//   Badge,
//   Email,
//   Visibility,
//   VisibilityOff,
//   AssignmentInd,
//   ArrowBack
// } from "@mui/icons-material";
// import { getMaxServiceNumber } from "../service/authService";

// // Import your background image
// import imge from "../assets/hom.gif";

// const Registration = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
  
//   const [loading, setLoading] = useState(false);
//   const [loadingServiceNo, setLoadingServiceNo] = useState(true);
//   const [showPassword, setShowPassword] = useState(false);
//   const [acceptedTerms, setAcceptedTerms] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [formData, setFormData] = useState({
//     ServiceNo: "",
//     Name: "",
//     MobileNo: "",
//     Email: "",
//     company: "",
//     role: "",
//     status: "A",
//     Location: "",
//     SLocation: "",
//     password: "",
//     confirmPassword: "",
//     qr: "N"
//   });
  
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     const fetchMaxServiceNumber = async () => {
//       try {
//         setLoadingServiceNo(true);
//         const response = await getMaxServiceNumber();
        
//         if (response.resultSet && response.resultSet[0] && response.resultSet[0].maxid) {
//           const maxId = response.resultSet[0].maxid;
//           const nextServiceNo = (parseInt(maxId)).toString();
          
//           setFormData(prev => ({
//             ...prev,
//             ServiceNo: nextServiceNo
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching max service number:", error);
//       } finally {
//         setLoadingServiceNo(false);
//       }
//     };

//     fetchMaxServiceNumber();

//     return () => {
//       document.body.style.backgroundColor = '';
//       document.documentElement.style.backgroundColor = '';
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
    
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ""
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     const requiredFields = ["ServiceNo", "Name", "MobileNo", "company", "role", "Location", "password", "confirmPassword"];
//     requiredFields.forEach(field => {
//       if (!formData[field] || !formData[field].toString().trim()) {
//         newErrors[field] = "Required";
//       }
//     });

//     if (formData.Email && !/\S+@\S+\.\S+/.test(formData.Email)) {
//       newErrors.Email = "Invalid email";
//     }

//     if (formData.MobileNo && formData.MobileNo.length < 10) {
//       newErrors.MobileNo = "10 digits required";
//     }

//     if (formData.password && formData.password.length < 8) {
//       newErrors.password = "Min 8 characters";
//     }

//     if (formData.password !== formData.confirmPassword) {
//       newErrors.confirmPassword = "Passwords don't match";
//     }

//     if (!acceptedTerms) {
//       newErrors.terms = "Accept terms to continue";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);
//     setSuccessMessage("");
    
//     try {
//       const { confirmPassword, ...registrationData } = formData;
      
//       const result = await dispatch(register(registrationData));
      
//       if (result.success) {
//         setSuccessMessage("Registration successful!");
//         setTimeout(() => {
//           navigate("/");
//         }, 1500);
//       } else {
//         alert(result.error?.message || "Registration failed.");
//       }
//     } catch (err) {
//       console.error("Registration error:", err);
//       alert("An error occurred.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <Container
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         backgroundColor: "#F8F9FA",
//         backgroundImage: `url(${imge})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         padding: 2,
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//       }}
//     >
//       <Paper
//         sx={{
//           borderRadius: 5,
//           boxShadow: 8,
//           padding: { xs: 3, sm: 4 },
//           maxWidth: 500,
//           width: "100%",
//           backgroundColor: "rgba(255, 255, 255, 0.95)",
//           overflowY: "auto",
//           maxHeight: "90vh",
//         }}
//       >
//         {/* Header */}
//         <Box sx={{ mb: 4, textAlign: "center" }}>
//           <Box
//             onClick={() => navigate("/")}
//             sx={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 1,
//               mb: 3,
//               color: "#666",
//               cursor: "pointer",
//               "&:hover": { color: "#000" }
//             }}
//           >
//             <ArrowBack fontSize="small" />
//             <Typography variant="body2">Back to login</Typography>
//           </Box>
          
//           <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: "#000" }}>
//             Create Account
//           </Typography>
//           <Typography variant="body2" sx={{ color: "#666" }}>
//             Fill in your details below
//           </Typography>
//         </Box>

//         {/* Form */}
//         <Box sx={{ mb: 3 }}>
//           {successMessage && (
//             <Alert severity="success" sx={{ mb: 2, borderRadius: 1 }}>
//               {successMessage}
//             </Alert>
//           )}

//           <Box component="form" onSubmit={handleSubmit}>
//             {/* Service No & Name - Inline */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Service No"
//                 name="ServiceNo"
//                 value={formData.ServiceNo}
//                 onChange={handleChange}
//                 error={!!errors.ServiceNo}
//                 helperText={errors.ServiceNo}
//                 disabled={true}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Badge sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Full Name"
//                 name="Name"
//                 value={formData.Name}
//                 onChange={handleChange}
//                 error={!!errors.Name}
//                 helperText={errors.Name}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Person sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Mobile & Email */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Mobile"
//                 name="MobileNo"
//                 value={formData.MobileNo}
//                 onChange={(e) => {
//                   const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
//                   setFormData(prev => ({ ...prev, MobileNo: value }));
//                   if (errors.MobileNo) setErrors(prev => ({ ...prev, MobileNo: "" }));
//                 }}
//                 error={!!errors.MobileNo}
//                 helperText={errors.MobileNo}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Phone sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Email"
//                 name="Email"
//                 value={formData.Email}
//                 onChange={handleChange}
//                 error={!!errors.Email}
//                 helperText={errors.Email}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Email sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Company & Role */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Company"
//                 name="company"
//                 value={formData.company}
//                 onChange={handleChange}
//                 error={!!errors.company}
//                 helperText={errors.company}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Business sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 select
//                 fullWidth
//                 size="small"
//                 label="Role"
//                 name="role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//                 SelectProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <AssignmentInd sx={{ fontSize: 18, color: "#999", mr: 1 }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               >
//                 <MenuItem value="A">Admin</MenuItem>
//                 <MenuItem value="U">User</MenuItem>
//                 <MenuItem value="S">Supervisor</MenuItem>
//               </TextField>
//             </Box>

//             {/* Locations */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Location"
//                 name="Location"
//                 value={formData.Location}
//                 onChange={handleChange}
//                 error={!!errors.Location}
//                 helperText={errors.Location}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <LocationOn sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Sub Location"
//                 name="SLocation"
//                 value={formData.SLocation}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <LocationOn sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Passwords */}
//             <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Password"
//                 name="password"
//                 type={showPassword ? "text" : "password"}
//                 value={formData.password}
//                 onChange={handleChange}
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={handleClickShowPassword}
//                         edge="end"
//                         size="small"
//                         sx={{ p: 0.5 }}
//                       >
//                         {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Confirm"
//                 name="confirmPassword"
//                 type={showPassword ? "text" : "password"}
//                 value={formData.confirmPassword}
//                 onChange={handleChange}
//                 error={!!errors.confirmPassword}
//                 helperText={errors.confirmPassword}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Terms */}
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={acceptedTerms}
//                   onChange={(e) => setAcceptedTerms(e.target.checked)}
//                   sx={{ p: 0.5, mr: 1 }}
//                 />
//               }
//               label={
//                 <Typography variant="caption" sx={{ color: errors.terms ? "#f44336" : "#666" }}>
//                   I agree to the terms and conditions
//                 </Typography>
//               }
//               sx={{ mb: 3, display: "block" }}
//             />

//             {/* Submit Button */}
//             <LoadingButton
//               type="submit"
//               loading={loading}
//               variant="contained"
//               fullWidth
//               size="medium"
//               sx={{
//                 bgcolor: "#1e0153",
//                 color: "#fff",
//                 borderRadius: 1,
//                 py: 1,
//                 fontSize: "0.875rem",
//                 fontWeight: 500,
//                 "&:hover": {
//                   bgcolor: "#333",
//                 },
//                 "&.Mui-disabled": {
//                   bgcolor: "#e0e0e0",
//                   color: "#999",
//                 },
//               }}
//             >
//               Register
//             </LoadingButton>
//           </Box>
//         </Box>

//         {/* Footer */}
//         <Box sx={{ textAlign: "center", mt: 3 }}>
//           <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
//             Already have an account?
//           </Typography>
//           <Link
//             onClick={() => navigate("/")}
//             sx={{
//               color: "#000",
//               textDecoration: "none",
//               cursor: "pointer",
//               fontWeight: 500,
//               "&:hover": { textDecoration: "underline" }
//             }}
//           >
//             Sign in here
//           </Link>
//         </Box>

//         {/* Service No Loading Indicator */}
//         {loadingServiceNo && (
//           <Box sx={{ textAlign: "center", mt: 2 }}>
//             <CircularProgress size={16} sx={{ color: "#666", mr: 1 }} />
//             <Typography variant="caption" sx={{ color: "#666" }}>
//               Generating service number...
//             </Typography>
//           </Box>
//         )}
//       </Paper>
//     </Container>
//   );
// };

// export default Registration;




// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { register } from "../actions/authActions";
// import {
//   Box,
//   Container,
//   Typography,
//   TextField,
//   MenuItem,
//   InputAdornment,
//   IconButton,
//   Paper,
//   Alert,
//   FormControlLabel,
//   Checkbox,
//   Link,
//   CircularProgress,
//   Avatar,
//   Button
// } from "@mui/material";
// import LoadingButton from "@mui/lab/LoadingButton";
// import { useNavigate } from "react-router-dom";
// import {
//   Person,
//   Phone,
//   Business,
//   LocationOn,
//   Lock,
//   Badge,
//   Email,
//   Visibility,
//   VisibilityOff,
//   AssignmentInd,
//   ArrowBack,
//   CloudUpload,
//   Clear
// } from "@mui/icons-material";
// import { getMaxServiceNumber } from "../service/authService";

// // Import your background image
// import imge from "../assets/hom.gif";

// const Registration = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
  
//   const [loading, setLoading] = useState(false);
//   const [loadingServiceNo, setLoadingServiceNo] = useState(true);
//   const [showPassword, setShowPassword] = useState(false);
//   const [acceptedTerms, setAcceptedTerms] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [profileImage, setProfileImage] = useState(null);
//   const [profileImagePreview, setProfileImagePreview] = useState(null);
//   const [uploadingImage, setUploadingImage] = useState(false);
//   const [uploadedImagePath, setUploadedImagePath] = useState(null);
//   const fileInputRef = React.useRef(null);
//   const [formData, setFormData] = useState({
//     ServiceNo: "",
//     Name: "",
//     MobileNo: "",
//     Email: "",
//     company: "",
//     role: "",
//     status: "A",
//     Location: "",
//     SLocation: "",
//     password: "",
//     confirmPassword: "",
//     qr: "N",
//     profilePicture: "" // For storing uploaded image path
//   });
  
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     const fetchMaxServiceNumber = async () => {
//       try {
//         setLoadingServiceNo(true);
//         const response = await getMaxServiceNumber();
        
//         if (response.resultSet && response.resultSet[0] && response.resultSet[0].maxid) {
//           const maxId = response.resultSet[0].maxid;
//           const nextServiceNo = (parseInt(maxId)).toString();
          
//           setFormData(prev => ({
//             ...prev,
//             ServiceNo: nextServiceNo
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching max service number:", error);
//       } finally {
//         setLoadingServiceNo(false);
//       }
//     };

//     fetchMaxServiceNumber();

//     return () => {
//       document.body.style.backgroundColor = '';
//       document.documentElement.style.backgroundColor = '';
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
    
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ""
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     const requiredFields = ["ServiceNo", "Name", "MobileNo", "company", "role", "Location", "password", "confirmPassword"];
//     requiredFields.forEach(field => {
//       if (!formData[field] || !formData[field].toString().trim()) {
//         newErrors[field] = "Required";
//       }
//     });

//     if (formData.Email && !/\S+@\S+\.\S+/.test(formData.Email)) {
//       newErrors.Email = "Invalid email";
//     }

//     if (formData.MobileNo && formData.MobileNo.length < 10) {
//       newErrors.MobileNo = "10 digits required";
//     }

//     if (formData.password && formData.password.length < 8) {
//       newErrors.password = "Min 8 characters";
//     }

//     if (formData.password !== formData.confirmPassword) {
//       newErrors.confirmPassword = "Passwords don't match";
//     }

//     if (!acceptedTerms) {
//       newErrors.terms = "Accept terms to continue";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);
//     setSuccessMessage("");
    
//     try {
//       // Upload profile image if selected
//       let imagePath = uploadedImagePath;
//       if (profileImage && !uploadedImagePath) {
//         imagePath = await uploadProfileImage(profileImage);
//         if (!imagePath) {
//           // Image upload failed, but continue with registration
//           console.warn('Image upload failed, continuing with registration');
//         }
//       }

//       const { confirmPassword, ...registrationData } = formData;
      
//       // Add uploaded image path to registration data
//       if (imagePath) {
//         registrationData.profilePicture = imagePath;
//       }
      
//       const result = await dispatch(register(registrationData));
      
//       if (result.success) {
//         setSuccessMessage("Registration successful!");
//         setTimeout(() => {
//           navigate("/");
//         }, 1500);
//       } else {
//         alert(result.error?.message || "Registration failed.");
//       }
//     } catch (err) {
//       console.error("Registration error:", err);
//       alert("An error occurred.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   // Handle profile image selection
//   const handleProfileImageChange = (event) => {
//     const file = event.target.files[0];
    
//     if (file) {
//       // Validate file type
//       const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
//       if (!validTypes.includes(file.type)) {
//         alert('Please select a valid image file (JPEG, PNG, GIF, or WebP)');
//         return;
//       }

//       // Validate file size (max 5MB)
//       if (file.size > 5 * 1024 * 1024) {
//         alert('Image size should not exceed 5MB');
//         return;
//       }

//       setProfileImage(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfileImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Upload profile image to API
//   const uploadProfileImage = async (file) => {
//     if (!file) {
//       return null;
//     }

//     if (!formData.ServiceNo) {
//       alert('Please enter Service Number first before uploading image.');
//       return null;
//     }

//     setUploadingImage(true);
//     const formDataForUpload = new FormData();
//     formDataForUpload.append('ImageFile', file);
//     formDataForUpload.append('ServiceNo', formData.ServiceNo);

//     console.log("Uploading image for ServiceNo:", formData.ServiceNo);
//     console.log("File details:", file.name, file.type, file.size);

//     try {
//       const response = await fetch(
//         `https://daladamaligawa.dockyardsoftware.com/User/Fileupload?ServiceNo=${formData.ServiceNo}`,
//         {
//           method: 'POST',
//           body: formDataForUpload
//         }
//       );

//       console.log("Upload response status:", response.status);
//       const responseData = await response.text();
//       console.log("Upload response data:", responseData);

//       if (!response.ok) {
//         throw new Error(responseData || 'Failed to upload image');
//       }
      
//       setUploadedImagePath(formData.ServiceNo);
//       setSuccessMessage('Profile picture uploaded successfully!');
      
//       return formData.ServiceNo;
//     } catch (error) {
//       console.error('Image upload error:', error);
//       alert('Failed to upload profile picture. Please try again.');
//       return null;
//     } finally {
//       setUploadingImage(false);
//     }
//   };

//   // Clear profile image
//   const handleClearImage = () => {
//     setProfileImage(null);
//     setProfileImagePreview(null);
//     setUploadedImagePath(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   return (
//     <Container
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         backgroundColor: "#F8F9FA",
//         backgroundImage: `url(${imge})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         padding: 2,
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//       }}
//     >
//       <Paper
//         sx={{
//           borderRadius: 5,
//           boxShadow: 8,
//           padding: { xs: 3, sm: 4 },
//           maxWidth: 500,
//           width: "100%",
//           backgroundColor: "rgba(255, 255, 255, 0.95)",
//           overflowY: "auto",
//           maxHeight: "90vh",
//         }}
//       >
//         {/* Header */}
//         <Box sx={{ mb: 4, textAlign: "center" }}>
//           <Box
//             onClick={() => navigate("/")}
//             sx={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 1,
//               mb: 3,
//               color: "#666",
//               cursor: "pointer",
//               "&:hover": { color: "#000" }
//             }}
//           >
//             <ArrowBack fontSize="small" />
//             <Typography variant="body2">Back to login</Typography>
//           </Box>
          
//           <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: "#000" }}>
//             Create Account
//           </Typography>
//           <Typography variant="body2" sx={{ color: "#666" }}>
//             Fill in your details below
//           </Typography>
//         </Box>

//         {/* Form */}
//         <Box sx={{ mb: 3 }}>
//           {successMessage && (
//             <Alert severity="success" sx={{ mb: 2, borderRadius: 1 }}>
//               {successMessage}
//             </Alert>
//           )}

//           <Box component="form" onSubmit={handleSubmit}>
//             {/* Service No & Name - Inline */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Service No"
//                 name="ServiceNo"
//                 value={formData.ServiceNo}
//                 onChange={handleChange}
//                 error={!!errors.ServiceNo}
//                 helperText={errors.ServiceNo}
//                 disabled={true}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Badge sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Full Name"
//                 name="Name"
//                 value={formData.Name}
//                 onChange={handleChange}
//                 error={!!errors.Name}
//                 helperText={errors.Name}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Person sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Mobile & Email */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Mobile"
//                 name="MobileNo"
//                 value={formData.MobileNo}
//                 onChange={(e) => {
//                   const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
//                   setFormData(prev => ({ ...prev, MobileNo: value }));
//                   if (errors.MobileNo) setErrors(prev => ({ ...prev, MobileNo: "" }));
//                 }}
//                 error={!!errors.MobileNo}
//                 helperText={errors.MobileNo}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Phone sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Email"
//                 name="Email"
//                 value={formData.Email}
//                 onChange={handleChange}
//                 error={!!errors.Email}
//                 helperText={errors.Email}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Email sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Company & Role */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Company"
//                 name="company"
//                 value={formData.company}
//                 onChange={handleChange}
//                 error={!!errors.company}
//                 helperText={errors.company}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Business sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 select
//                 fullWidth
//                 size="small"
//                 label="Role"
//                 name="role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//                 SelectProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <AssignmentInd sx={{ fontSize: 18, color: "#999", mr: 1 }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               >
//                 <MenuItem value="A">Admin</MenuItem>
//                 <MenuItem value="U">User</MenuItem>
//                 <MenuItem value="S">Supervisor</MenuItem>
//               </TextField>
//             </Box>

//             {/* Locations */}
//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Location"
//                 name="Location"
//                 value={formData.Location}
//                 onChange={handleChange}
//                 error={!!errors.Location}
//                 helperText={errors.Location}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <LocationOn sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Sub Location"
//                 name="SLocation"
//                 value={formData.SLocation}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <LocationOn sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Passwords */}
//             <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Password"
//                 name="password"
//                 type={showPassword ? "text" : "password"}
//                 value={formData.password}
//                 onChange={handleChange}
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={handleClickShowPassword}
//                         edge="end"
//                         size="small"
//                         sx={{ p: 0.5 }}
//                       >
//                         {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
              
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Confirm"
//                 name="confirmPassword"
//                 type={showPassword ? "text" : "password"}
//                 value={formData.confirmPassword}
//                 onChange={handleChange}
//                 error={!!errors.confirmPassword}
//                 helperText={errors.confirmPassword}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ fontSize: 18, color: "#999" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     fontSize: "0.875rem",
//                     "&:hover fieldset": {
//                       borderColor: "#000",
//                     },
//                   },
//                 }}
//               />
//             </Box>

//             {/* Profile Picture Upload Section */}
//             <Box sx={{ mb: 3, p: 2, borderRadius: 1, border: "2px dashed #ccc", textAlign: "center", backgroundColor: "#f9f9f9" }}>
//               <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: "#333" }}>
//                 Upload Profile Picture
//               </Typography>
              
//               {profileImagePreview ? (
//                 <Box sx={{ mb: 2, position: "relative", display: "inline-block" }}>
//                   <Avatar
//                     src={profileImagePreview}
//                     sx={{ width: 120, height: 120, border: "3px solid #1e0153" }}
//                   />
//                   <IconButton
//                     size="small"
//                     onClick={handleClearImage}
//                     sx={{
//                       position: "absolute",
//                       top: -10,
//                       right: -10,
//                       bgcolor: "#f44336",
//                       color: "white",
//                       "&:hover": { bgcolor: "#d32f2f" }
//                     }}
//                   >
//                     <Clear fontSize="small" />
//                   </IconButton>
//                 </Box>
//               ) : (
//                 <Box sx={{ mb: 2 }}>
//                   <CloudUpload sx={{ fontSize: 48, color: "#999", mb: 1 }} />
//                   <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
//                     Click below to select an image
//                   </Typography>
//                 </Box>
//               )}

//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleProfileImageChange}
//                 style={{ display: "none" }}
//               />

//               <Button
//                 variant="outlined"
//                 size="small"
//                 onClick={() => fileInputRef.current?.click()}
//                 disabled={uploadingImage}
//                 sx={{
//                   borderColor: "#1e0153",
//                   color: "#1e0153",
//                   "&:hover": {
//                     borderColor: "#1e0153",
//                     backgroundColor: "rgba(30, 1, 83, 0.04)"
//                   }
//                 }}
//               >
//                 {uploadingImage ? "Uploading..." : "Choose Image"}
//               </Button>

//               {profileImage && (
//                 <Box sx={{ mt: 2 }}>
//                   <LoadingButton
//                     variant="contained"
//                     size="small"
//                     loading={uploadingImage}
//                     onClick={() => uploadProfileImage(profileImage)}
//                     sx={{
//                       bgcolor: "#1e0153",
//                       "&:hover": { bgcolor: "#333" }
//                     }}
//                   >
//                     Upload Picture
//                   </LoadingButton>
//                 </Box>
//               )}

//               {uploadedImagePath && (
//                 <Alert severity="success" sx={{ mt: 2, fontSize: "0.75rem" }}>
//                   Profile picture uploaded successfully!
//                 </Alert>
//               )}

//               <Typography variant="caption" sx={{ display: "block", mt: 2, color: "#999" }}>
//                 Supported formats: JPEG, PNG, GIF, WebP (Max 5MB)
//               </Typography>
//             </Box>

//             {/* Terms */}
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={acceptedTerms}
//                   onChange={(e) => setAcceptedTerms(e.target.checked)}
//                   sx={{ p: 0.5, mr: 1 }}
//                 />
//               }
//               label={
//                 <Typography variant="caption" sx={{ color: errors.terms ? "#f44336" : "#666" }}>
//                   I agree to the terms and conditions
//                 </Typography>
//               }
//               sx={{ mb: 3, display: "block" }}
//             />

//             {/* Submit Button */}
//             <LoadingButton
//               type="submit"
//               loading={loading}
//               variant="contained"
//               fullWidth
//               size="medium"
//               sx={{
//                 bgcolor: "#1e0153",
//                 color: "#fff",
//                 borderRadius: 1,
//                 py: 1,
//                 fontSize: "0.875rem",
//                 fontWeight: 500,
//                 "&:hover": {
//                   bgcolor: "#333",
//                 },
//                 "&.Mui-disabled": {
//                   bgcolor: "#e0e0e0",
//                   color: "#999",
//                 },
//               }}
//             >
//               Register
//             </LoadingButton>
//           </Box>
//         </Box>

//         {/* Footer */}
//         <Box sx={{ textAlign: "center", mt: 3 }}>
//           <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
//             Already have an account?
//           </Typography>
//           <Link
//             onClick={() => navigate("/")}
//             sx={{
//               color: "#000",
//               textDecoration: "none",
//               cursor: "pointer",
//               fontWeight: 500,
//               "&:hover": { textDecoration: "underline" }
//             }}
//           >
//             Sign in here
//           </Link>
//         </Box>

//         {/* Service No Loading Indicator */}
//         {loadingServiceNo && (
//           <Box sx={{ textAlign: "center", mt: 2 }}>
//             <CircularProgress size={16} sx={{ color: "#666", mr: 1 }} />
//             <Typography variant="caption" sx={{ color: "#666" }}>
//               Generating service number...
//             </Typography>
//           </Box>
//         )}
//       </Paper>
//     </Container>
//   );
// };

// export default Registration;






import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { register } from "../actions/authActions";
import {
  Box,
  Container,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  IconButton,
  Paper,
  Alert,
  FormControlLabel,
  Checkbox,
  Link,
  CircularProgress,
  Avatar,
  Button,
  Autocomplete,
  useTheme,
  useMediaQuery
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";
import {
  Person,
  Phone,
  Business,
  LocationOn,
  Lock,
  Badge,
  Email,
  Visibility,
  VisibilityOff,
  AssignmentInd,
  ArrowBack,
  CloudUpload,
  Clear
} from "@mui/icons-material";
import { getMaxServiceNumber } from "../service/authService";
import departmentService from "../service/departmentService";
import { apiUrl } from "../service/apiUrl";

// Import your background images
import desktopBackground from "../assets/homd.png"; // Desktop background
import mobileBackground from "../assets/hom.gif"; // Mobile background - replace with your mobile image

const Registration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Check for mobile view
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [loading, setLoading] = useState(false);
  const [loadingServiceNo, setLoadingServiceNo] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [uploadedImagePath, setUploadedImagePath] = useState(null);
  const fileInputRef = React.useRef(null);
  const [locationOptions, setLocationOptions] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [formData, setFormData] = useState({
    ServiceNo: "",
    Name: "",
    MobileNo: "",
    Department: "",
    company: "",
    role: "",
    status: "A",
    Location: "",
    SLocation: "",
    password: "",
    confirmPassword: "",
    qr: "N",
    profilePicture: "" // For storing uploaded image path
  });
  
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchMaxServiceNumber = async () => {
      try {
        setLoadingServiceNo(true);
        const response = await getMaxServiceNumber();
        
        if (response.resultSet && response.resultSet[0] && response.resultSet[0].maxid) {
          const maxId = response.resultSet[0].maxid;
          const nextServiceNo = (parseInt(maxId)).toString();
          
          setFormData(prev => ({
            ...prev,
            ServiceNo: nextServiceNo
          }));
        }
      } catch (error) {
        console.error("Error fetching max service number:", error);
      } finally {
        setLoadingServiceNo(false);
      }
    };

    fetchMaxServiceNumber();

    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, []);

  // Fetch locations from API
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setLoadingLocations(true);
        const response = await fetch(apiUrl('UserDetails/Locations'));
        const data = await response.json();
        if (data.statusCode === 200 && data.resultSet) {
          setLocationOptions(data.resultSet);
        }
      } catch (error) {
        console.error('Error fetching locations:', error);
      } finally {
        setLoadingLocations(false);
      }
    };
    fetchLocations();
  }, []);

  // Fetch departments from API
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        setLoadingDepartments(true);
        const departments = await departmentService.getDepartments();
        setDepartmentOptions(departments);
      } catch (error) {
        console.error('Error fetching departments:', error);
      } finally {
        setLoadingDepartments(false);
      }
    };
    fetchDepartments();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    const requiredFields = ["ServiceNo", "Name", "MobileNo", "Department", "company", "role", "Location", "password", "confirmPassword"];
    requiredFields.forEach(field => {
      if (!formData[field] || !formData[field].toString().trim()) {
        newErrors[field] = "Required";
      }
    });

    if (formData.MobileNo && formData.MobileNo.length < 10) {
      newErrors.MobileNo = "10 digits required";
    }

    if (formData.password && formData.password.length < 8) {
      newErrors.password = "Min 8 characters";
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords don't match";
    }

    if (!acceptedTerms) {
      newErrors.terms = "Accept terms to continue";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setSuccessMessage("");
    
    try {
      // Upload profile image if selected
      let imagePath = uploadedImagePath;
      if (profileImage && !uploadedImagePath) {
        imagePath = await uploadProfileImage(profileImage);
        if (!imagePath) {
          // Image upload failed, but continue with registration
          console.warn('Image upload failed, continuing with registration');
        }
      }

      const { confirmPassword, ...registrationData } = formData;
      
      // Add uploaded image path to registration data
      if (imagePath) {
        registrationData.profilePicture = imagePath;
      }
      
      const result = await dispatch(register(registrationData));
      
      if (result.success) {
        setSuccessMessage("Registration successful!");
        setTimeout(() => {
          navigate("/");
        }, 1500);
      } else {
        alert(result.error?.message || "Registration failed.");
      }
    } catch (err) {
      console.error("Registration error:", err);
      alert("An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Handle profile image selection
  const handleProfileImageChange = (event) => {
    const file = event.target.files[0];
    
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        alert('Please select a valid image file (JPEG, PNG, GIF, or WebP)');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size should not exceed 5MB');
        return;
      }

      setProfileImage(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Upload profile image to API
  const uploadProfileImage = async (file) => {
    if (!file) {
      return null;
    }

    if (!formData.ServiceNo) {
      alert('Please enter Service Number first before uploading image.');
      return null;
    }

    setUploadingImage(true);
    const formDataForUpload = new FormData();
    formDataForUpload.append('ImageFile', file);
    formDataForUpload.append('ServiceNo', formData.ServiceNo);

    console.log("Uploading image for ServiceNo:", formData.ServiceNo);
    console.log("File details:", file.name, file.type, file.size);

    try {
      const response = await fetch(
        apiUrl(`User/Fileupload?ServiceNo=${formData.ServiceNo}`),
        {
          method: 'POST',
          body: formDataForUpload
        }
      );

      console.log("Upload response status:", response.status);
      const responseData = await response.text();
      console.log("Upload response data:", responseData);

      if (!response.ok) {
        throw new Error(responseData || 'Failed to upload image');
      }
      
      setUploadedImagePath(formData.ServiceNo);
      setSuccessMessage('Profile picture uploaded successfully!');
      
      return formData.ServiceNo;
    } catch (error) {
      console.error('Image upload error:', error);
      alert('Failed to upload profile picture. Please try again.');
      return null;
    } finally {
      setUploadingImage(false);
    }
  };

  // Clear profile image
  const handleClearImage = () => {
    setProfileImage(null);
    setProfileImagePreview(null);
    setUploadedImagePath(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#F8F9FA",
        // Conditional background image based on screen size
        backgroundImage: isMobile 
          ? `url(${mobileBackground})` 
          : `url(${desktopBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        padding: 2,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        // Optional: Add a fallback background color with overlay
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          zIndex: -1,
        }
      }}
      maxWidth={false}
    >
      <Paper
        sx={{
          borderRadius: 5,
          boxShadow: 8,
          padding: { xs: 3, sm: 4 },
          maxWidth: 500,
          width: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          overflowY: "auto",
          maxHeight: "90vh",
          // Optional: Different styling for mobile
          ...(isMobile && {
            margin: 1,
            padding: 2,
            borderRadius: 3,
          })
        }}
      >
        {/* Header */}
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Box
            onClick={() => navigate("/")}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              mb: 3,
              color: "#666",
              cursor: "pointer",
              "&:hover": { color: "#000" }
            }}
          >
            <ArrowBack fontSize="small" />
            <Typography variant="body2">Back to login</Typography>
          </Box>
          
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: "#000" }}>
            Create Account
          </Typography>
          <Typography variant="body2" sx={{ color: "#666" }}>
            Fill in your details below
          </Typography>
        </Box>

        {/* Form */}
        <Box sx={{ mb: 3 }}>
          {successMessage && (
            <Alert severity="success" sx={{ mb: 2, borderRadius: 1 }}>
              {successMessage}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            {/* Service No & Name - Inline */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                fullWidth
                size="small"
                label="Service No"
                name="ServiceNo"
                value={formData.ServiceNo}
                onChange={handleChange}
                error={!!errors.ServiceNo}
                helperText={errors.ServiceNo}
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Badge sx={{ fontSize: 18, color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />
              
              <TextField
                fullWidth
                size="small"
                label="Full Name"
                name="Name"
                value={formData.Name}
                onChange={handleChange}
                error={!!errors.Name}
                helperText={errors.Name}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person sx={{ fontSize: 18, color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />
            </Box>

            {/* Mobile & Department */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                fullWidth
                size="small"
                label="Mobile"
                name="MobileNo"
                value={formData.MobileNo}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                  setFormData(prev => ({ ...prev, MobileNo: value }));
                  if (errors.MobileNo) setErrors(prev => ({ ...prev, MobileNo: "" }));
                }}
                error={!!errors.MobileNo}
                helperText={errors.MobileNo}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone sx={{ fontSize: 18, color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />
              
              <Autocomplete
                fullWidth
                options={departmentOptions}
                getOptionLabel={(option) => {
                  // Handle both object and string values
                  if (typeof option === 'string') {
                    const found = departmentOptions.find(dep => dep.depCode === option);
                    return found ? found.depName : option;
                  }
                  return option.depName || '';
                }}
                value={departmentOptions.find(dep => dep.depCode === formData.Department) || null}
                onChange={(event, newValue) => {
                  // Store depCode in formData.Department
                  setFormData(prev => ({ ...prev, Department: newValue ? newValue.depCode : "" }));
                  if (errors.Department) setErrors(prev => ({ ...prev, Department: "" }));
                }}
                isOptionEqualToValue={(option, value) => option.depCode === value?.depCode}
                loading={loadingDepartments}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Department"
                    error={!!errors.Department}
                    helperText={errors.Department}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <Business sx={{ fontSize: 18, color: "#999" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontSize: "0.875rem",
                        "&:hover fieldset": {
                          borderColor: "#000",
                        },
                      },
                    }}
                  />
                )}
                freeSolo={false}
                disableClearable={false}
              />
            </Box>

            {/* Company & Role */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                fullWidth
                size="small"
                label="Company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                error={!!errors.company}
                helperText={errors.company}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Business sx={{ fontSize: 18, color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />
              
              <TextField
                select
                fullWidth
                size="small"
                label="Role"
                name="role"
                value={formData.role}
                onChange={handleChange}
                error={!!errors.role}
                helperText={errors.role}
                SelectProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AssignmentInd sx={{ fontSize: 18, color: "#999", mr: 1 }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              >
                <MenuItem value="A">Admin</MenuItem>
                <MenuItem value="U">User</MenuItem>
                <MenuItem value="S">Supervisor</MenuItem>
              </TextField>
            </Box>

            {/* Locations */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Autocomplete
                fullWidth
                options={locationOptions}
                getOptionLabel={(option) => {
                  // Handle both object and string values
                  if (typeof option === 'string') {
                    const found = locationOptions.find(loc => loc.locCode === option);
                    return found ? found.locName : option;
                  }
                  return option.locName || '';
                }}
                value={locationOptions.find(loc => loc.locCode === formData.Location) || null}
                onChange={(event, newValue) => {
                  // Store locCode in formData.Location
                  setFormData(prev => ({ ...prev, Location: newValue ? newValue.locCode : "" }));
                  if (errors.Location) setErrors(prev => ({ ...prev, Location: "" }));
                }}
                isOptionEqualToValue={(option, value) => option.locCode === value?.locCode}
                loading={loadingLocations}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Location"
                    error={!!errors.Location}
                    helperText={errors.Location}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocationOn sx={{ fontSize: 18, color: "#999" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontSize: "0.875rem",
                        "&:hover fieldset": {
                          borderColor: "#000",
                        },
                      },
                    }}
                  />
                )}
                freeSolo={false}
                disableClearable={false}
              />
              
              <TextField
                fullWidth
                size="small"
                label="Sub Location"
                name="SLocation"
                value={formData.SLocation}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationOn sx={{ fontSize: 18, color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />
            </Box>

            {/* Passwords */}
            <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                size="small"
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ fontSize: 18, color: "#999" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        size="small"
                        sx={{ p: 0.5 }}
                      >
                        {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />
              
              <TextField
                fullWidth
                size="small"
                label="Confirm"
                name="confirmPassword"
                type={showPassword ? "text" : "password"}
                value={formData.confirmPassword}
                onChange={handleChange}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ fontSize: 18, color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.875rem",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />
            </Box>

            {/* Profile Picture Upload Section */}
            <Box sx={{ mb: 3, p: 2, borderRadius: 1, border: "2px dashed #ccc", textAlign: "center", backgroundColor: "#f9f9f9" }}>
              <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: "#333" }}>
                Upload Profile Picture
              </Typography>
              
              {profileImagePreview ? (
                <Box sx={{ mb: 2, position: "relative", display: "inline-block" }}>
                  <Avatar
                    src={profileImagePreview}
                    sx={{ width: 120, height: 120, border: "3px solid #1e0153" }}
                  />
                  <IconButton
                    size="small"
                    onClick={handleClearImage}
                    sx={{
                      position: "absolute",
                      top: -10,
                      right: -10,
                      bgcolor: "#f44336",
                      color: "white",
                      "&:hover": { bgcolor: "#d32f2f" }
                    }}
                  >
                    <Clear fontSize="small" />
                  </IconButton>
                </Box>
              ) : (
                <Box sx={{ mb: 2 }}>
                  <CloudUpload sx={{ fontSize: 48, color: "#999", mb: 1 }} />
                  <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                    Click below to select an image
                  </Typography>
                </Box>
              )}

              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleProfileImageChange}
                style={{ display: "none" }}
              />

              <Button
                variant="outlined"
                size="small"
                onClick={() => fileInputRef.current?.click()}
                disabled={uploadingImage}
                sx={{
                  borderColor: "#1e0153",
                  color: "#1e0153",
                  "&:hover": {
                    borderColor: "#1e0153",
                    backgroundColor: "rgba(30, 1, 83, 0.04)"
                  }
                }}
              >
                {uploadingImage ? "Uploading..." : "Choose Image"}
              </Button>

              {profileImage && (
                <Box sx={{ mt: 2 }}>
                  <LoadingButton
                    variant="contained"
                    size="small"
                    loading={uploadingImage}
                    onClick={() => uploadProfileImage(profileImage)}
                    sx={{
                      bgcolor: "#1e0153",
                      "&:hover": { bgcolor: "#333" }
                    }}
                  >
                    Upload Picture
                  </LoadingButton>
                </Box>
              )}

              {uploadedImagePath && (
                <Alert severity="success" sx={{ mt: 2, fontSize: "0.75rem" }}>
                  Profile picture uploaded successfully!
                </Alert>
              )}

              <Typography variant="caption" sx={{ display: "block", mt: 2, color: "#999" }}>
                Supported formats: JPEG, PNG, GIF, WebP (Max 5MB)
              </Typography>
            </Box>

            {/* Terms */}
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                  sx={{ p: 0.5, mr: 1 }}
                />
              }
              label={
                <Typography variant="caption" sx={{ color: errors.terms ? "#f44336" : "#666" }}>
                  I agree to the terms and conditions
                </Typography>
              }
              sx={{ mb: 3, display: "block" }}
            />

            {/* Submit Button */}
            <LoadingButton
              type="submit"
              loading={loading}
              variant="contained"
              fullWidth
              size="medium"
              sx={{
                bgcolor: "#1e0153",
                color: "#fff",
                borderRadius: 1,
                py: 1,
                fontSize: "0.875rem",
                fontWeight: 500,
                "&:hover": {
                  bgcolor: "#333",
                },
                "&.Mui-disabled": {
                  bgcolor: "#e0e0e0",
                  color: "#999",
                },
              }}
            >
              Register
            </LoadingButton>
          </Box>
        </Box>

        {/* Footer */}
        <Box sx={{ textAlign: "center", mt: 3 }}>
          <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
            Already have an account?
          </Typography>
          <Link
            onClick={() => navigate("/")}
            sx={{
              color: "#000",
              textDecoration: "none",
              cursor: "pointer",
              fontWeight: 500,
              "&:hover": { textDecoration: "underline" }
            }}
          >
            Sign in here
          </Link>
        </Box>

        {/* Service No Loading Indicator */}
        {loadingServiceNo && (
          <Box sx={{ textAlign: "center", mt: 2 }}>
            <CircularProgress size={16} sx={{ color: "#666", mr: 1 }} />
            <Typography variant="caption" sx={{ color: "#666" }}>
              Generating service number...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default Registration;